import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import SubGrupoContext from '../../../context/subgrupo/subgrupoContext';
import clienteAxios from '../../../service/axios';
import AuthContext from '../../../context/autentication/authContext';

////////// estilos ///////////////
const useStyles = makeStyles((theme) => ({
  formControl: {
    width: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));




export default function SelectorSubGrupos( {grupos,elegido,subGrupos,func, subElegido, actual, idActual, setAdd}) {
  ////////// estilos ///////////////
  const classes = useStyles();
  ///////////////// variables ////////////////
  const subgrupoContext = useContext(SubGrupoContext);
  const { obtenerSubGrupos } = subgrupoContext;
  const [age, setAge] = useState('');
  const [subG, setSubG] = useState()
  const authContext = useContext(AuthContext);
  const { autenticado, cliente, usuario } = authContext;
  const [hashGrupos, setHashGrupos]= useState({});
  let arrayGrupos = [];
  const [stringsG, setStringsG] = useState([ ]) 
  const [state, setState] = useState('');
  const [input, setInput]= useState(actual)

  useEffect(() => {
    if (elegido){
      let auxHash = {}
      grupos.subGrupo.map( g => {
        auxHash[g.nombre] = g
        arrayGrupos.push(g.nombre)
      })
      setHashGrupos(auxHash)
      setStringsG(arrayGrupos)
    } else if (subGrupos){
      let auxHash = {}
      subGrupos.map( g => {
        auxHash[g.nombre] = g
        arrayGrupos.push(g.nombre)
      })
      setHashGrupos(auxHash)
      setStringsG(arrayGrupos)
    }  
  }, []);

  ///////////////// variables ////////////////
  const [selectElegido, setSelectElegido] = useState("")
  const handleChange = async(event) => {
    setSelectElegido(event.target.value)
    const a = event.target.value
    func(null);
    func(a);
    setInput("")
  };

  return (
    <div>
      {actual ?
        <FormControl className={classes.formControl} margin="normal" style={{margin:"5px"}}>
        <InputLabel id="subgrupo">{(input!=="") ? actual : "Subgrupo" }</InputLabel>
        <Select
          labelId="subgrupo"
          id="subgrupo"
          value={age.nombre}
          onChange={handleChange}
          label="Subrupo"
          margin="normal"
        >
          <MenuItem  value={""} onClick={()=>setAdd("addsubgrupo")}>{<i>Crear Subgrupo</i>}</MenuItem>
          {subGrupos.map((g) => ( 
              <MenuItem value={g}>{g.nombre}</MenuItem>
            ))
          }
        </Select>
      </FormControl>
      : null} 
    </div>
  );
};


